export default __webpack_public_path__ + "static/media/623.38ca56c5.png";